import React from "react";
import Date from "./Date";

const BreakoutDate = ({ value, format }) => {
  return <Date value={value} format={format} up />;
};

export default BreakoutDate;
